export default "__VITE_ASSET__C7sUVt6c__"